import { IDeleteAccountRequestProps } from "../../models/User";
import { useCommonFetcher } from "../Common/CommonViewModel";
import { requestDeleteAccount as requestDeleteAccountApi } from "../../network/user";
import { getLocalisedString } from "../../utils/stringHelper";
export const useDeleteAccountViewModel = () => {
  const { fetcher } = useCommonFetcher();

  const requestDeleteAccount = async (payload: IDeleteAccountRequestProps) => {
    const res = await fetcher({
      api: () => requestDeleteAccountApi(payload),
      skipErrorHandle: true,
    });

    console.log(payload, res);

    if (res.success) {
      return {
        success: true,
        message: getLocalisedString(
          res.result?.message?.en,
          res.result?.message?.zh,
          true
        ),
      };
    } else {
      return {
        success: false,
        message: getLocalisedString(
          res.error?.localizedMessage?.en,
          res.error?.localizedMessage?.zh
        ),
      };
    }
  };

  return {
    requestDeleteAccount,
  };
};
